module.exports = __webpack_public_path__ + "img/exam_show_bg.6c910542.png";